<template>
  <div class="ms-container">
    <div class="filters-bar">
      <module-header style="margin-bottom: 0">Запросы материалов</module-header>
      <div class="filters-bar-right">
        <procedures-filter />
        <div class="resources-export-button">
          <i-button @click="exportData" type="primary" icon="md-cloud-download">
            Скачать документы
          </i-button>
        </div>
      </div>
    </div>
    <div class="procedures-all">
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить список запросов. Повторите, пожалуйста, попытку
        позже
      </div>
      <procedures-list
        :procedures="procedures"
        :all="true"
        v-else-if="procedures.length"
        @open-procedure="openProcedure"
      />
      <div v-else class="ms-nodata ms-text">
        Запросы материалов отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
import ModuleHeader from '@/components/parts/module-header'
import ProceduresList from '@/components/procedures/procedures-list'
import InlineLoader from '@/components/loaders/inline-loader'
import ProceduresFilter from '@/components/filters/procedures'
import { downloadFile } from '@/utils'
import { mainUrl } from '@/config/urls'
import { getProceduresUrl } from '@/config/filters'

export default {
  components: {
    ModuleHeader,
    ProceduresList,
    InlineLoader,
    ProceduresFilter
  },
  data () {
    return {
      loading: false,
      nodata: false,
      procedures: [],
      token: this.$store.state.auth.token
    }
  },
  watch: {
    '$store.state.filters.procedures': {
      handler: function () {
        this.getData(true)
      },
      deep: true
    }
  },
  methods: {
    async getData () {
      try {
        this.loading = true
        const url = getProceduresUrl(
          `page/procedure?`,
          this.$store.state.filters.procedures
        )
        this.procedures = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    openProcedure ({ id, contract_id }) {
      this.$router.push(`/app/contracts/${contract_id}/procedures?open=${id}`)
    },
    exportData () {
      const baseUrl = `page/all_document?contract_id=all&as_file=true&object_type=procedures`
      const url = getProceduresUrl(
        `${mainUrl}/api/${baseUrl}&access_token=${this.token}`,
        this.$store.state.filters.procedures
      )

      console.log(url)

      downloadFile(url)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style>
</style>
